import { Modal, Button, Alert } from 'components/common';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { cloneRole } from 'redux/authorization/roleSlice';
import { useNavigate } from 'react-router-dom';
import { FaBan, FaClone } from 'react-icons/fa';
import React from "react";
import PropTypes from 'prop-types';

const RoleDetailClone = ({showModal, setshowModal, role}) => {
  const { register, handleSubmit, formState: {errors} } = useForm()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  
  const onSubmit = async (data) => {
    console.log(data)

    try {
      if (role) {
        const roleId = role.id
        const response = await dispatch(cloneRole({sourceRoleId: roleId, data}))
        const newRoleId = response.payload.data.id

        toast.success(`Role ${data.name} has been cloned successful.`)
        closeModal()

        //navigate RoleDetail
        navigate(`/authorization/roles/${newRoleId}`)
      }
    }
    catch(error) {
      console.log(error.message)
      toast.error(error.message)
    }
  }

  const closeModal = () => {
    setshowModal(false)
  }

  const handleCancel = () => {
    closeModal()
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={closeModal}
        title={<><FaClone /> Clone new Role</>}
        size="md"
        footer={
          <>
            <Button type="submit" form="clone-role-form" size="sm"><FaClone /> Clone</Button>
            <Button variant="danger" size="sm" onClick={handleCancel}><FaBan /> Cancel</Button>
          </>
        }
      >
        <form id="clone-role-form" onSubmit={handleSubmit(onSubmit)}>
          <Alert type="info" message={<>All permissions of role <strong>{role.name}</strong> will be copied to destination role !</>} />

          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-items-start tw-mb-3">
            <label className="tw-col-span-3 tw-text-sm tw-font-medium tw-text-gray-600 tw-text-right tw-pt-1.5">
              Role name
            </label>
            <div className="tw-col-span-9">
              <textarea
                name="name"
                placeholder="Role name"
                autoComplete="role-name"
                rows={2}
                className="tw-w-full tw-border tw-border-gray-300 tw-rounded-md tw-px-3 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
                {...register('name', {
                  required: 'Name must be required'
                })}
              />
              <span className="tw-text-red-500 tw-text-xs">
                {errors.name && errors.name.message}
              </span>
            </div>
          </div>
        </form>
      </Modal>
    </>
  )
};

RoleDetailClone.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  role: PropTypes.object.isRequired
}


export default RoleDetailClone;